//import Footer from "../UI/Footer";
import Dailyfish from "../UI/Dailyfish";
import ControlledCarousel from "../UI/ControlledCarousel";
import TitleHeader from "../UI/TitleHeader";

function Home () {



  return ( 
    <>
      <TitleHeader />
      <ControlledCarousel />
      <Dailyfish />
    </>
  )
}

export default Home